var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirmen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFD7-Grundlagen:-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-956.000000, -1233.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Firmen",
    transform: "translate(956.000000, 1234.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,24 L10,1.195 C10,0.535 10.486,0 11.086,0 L20.914,0 C21.514,0 22,0.535 22,1.195 L22,24",
    id: "Grosses-Haus",
    stroke: "#969899",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fenster-7",
    fill: "#969899",
    points: "13 5 19 5 19 3 13 3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fenster-6",
    fill: "#969899",
    points: "13 9 19 9 19 7 13 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,12 C17.275,12 17.5243631,12.1135767 17.7053932,12.2946068 C17.8864233,12.4756369 18,12.725 18,13 L18,13 L18,23.9998333 L2,23.9971667 L2,13 C2,12.725 2.11357666,12.4756369 2.29460678,12.2946068 C2.4756369,12.1135767 2.725,12 3,12 L3,12 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 2,
    fill: "#EEEFF0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fenster-5",
    fill: "#969899",
    points: "5 17 7 17 7 15 5 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fenster-4",
    fill: "#969899",
    points: "9 17 11 17 11 15 9 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fenster-3",
    fill: "#969899",
    points: "13 17 15 17 15 15 13 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fenster-2",
    fill: "#969899",
    points: "5 21 7 21 7 19 5 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fenster-1",
    fill: "#969899",
    points: "13 21 15 21 15 19 13 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#969899",
    points: "9 23 11 23 11 19 9 19"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmen);
export default __webpack_public_path__ + "static/media/firmen.8ac57ac7122ffbb6e49e3833e80bc40e.svg";
export { ForwardRef as ReactComponent };